import { Component, ViewChild, Optional, Inject, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { BaseControlComponent } from "../base/base-control.component";
import { NG_VALUE_ACCESSOR, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { retry } from 'rxjs/operators';
import { CorrectYeKeService } from 'src/services/correctyeke.service';
@Component({
    //moduleId: module.id,
    selector: 'sep-input',
    styleUrls: ['input.component.scss'],
    templateUrl: 'input.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: InputComponent, multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class InputComponent extends BaseControlComponent<string>    {
    isshow: boolean;
    show() {
        this.isshow = !this.isshow;
    }
    focusFunction() {
        this.isshow = true;
        document.getElementById(this.name).focus();
    }
    focusOutFunction() {
        if (!this.value || this.value == '') {
            this.isshow = false;
        }
    }
    // @HostBinding('class') @Input('class') classList: string = '';

    @Input() class: string
    @Input() name: string;
    @Input() hint: string;
    @Input() icon: string;
    @Input() autocomplete: string = "on";
    @Input() withComma: boolean = true;
    @Output() numberValueChange: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(NgModel) model: NgModel;
    @Input() inputMask: string;
    _value: number;
    @Input()
    set numberValue(value: any) {
        if (value && this.textType == 'number' && this.withComma.toString().toLowerCase() === 'true') {
            var parts = value.toString().split(".");
            parts[0] = parts[0].replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.value = parts.join(".");
        }
        else
            this.value = value as any;
    }
    get numberValue(): any {
        if (this.textType == 'number' && this.withComma.toString().toLowerCase() === 'true') {
            return Number(this.value.replace(/,/g, ""));
        }
        return this.value as any;
    }
    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private cyk: CorrectYeKeService
    ) {
        super(validators, asyncValidators);
        if (!this.autocomplete) {
            this.autocomplete = "on";
        }
    }
    onChange(value: any) {
        if (value && this.textType == 'number' && this.withComma.toString().toLowerCase() === 'true') {
            this.valueChange.emit(this.value.replace(/,/g, ""));
            this.numberValueChange.emit(this.numberValue)
        }
        else {
            this.value = CorrectYeKeService.getCorrectYeKe(this.value);
            this.valueChange.emit(this.value);
            this.numberValueChange.emit(this.numberValue)
        }
    }
}
